import React from 'react';
import axios from 'axios';

import Api from '../util/Api';
import Log from '../util/Log';
import GtmHelper from '../util/GtmHelper';
import VoucherItem from './VoucherItem.jsx';
import VoucherForm from './VoucherForm.jsx';
import VoucherSuccess from './VoucherSuccess.jsx';
import VoucherCancel from './VoucherCancel.jsx';

class Vouchers extends React.Component {
    constructor () {
        super()
        this.state = this.getEmptyState();

        var url = new URL(window.location.href);
        this.state.sessionId = url.searchParams.get('session_id');
        this.state.cancelOrder = url.searchParams.get('cancel_order');
    }

    getEmptyState() {
        return {
            vouchers: [],
            voucherExpanded: false,
            sessionId: undefined
        }
    }

    componentDidMount() {
        this.fetchVouchers();
    }

    fetchVouchers() {
        Api.getVouchers((success, vouchers) => {
            vouchers.unshift(this.getEmptyVoucher());
            this.setState({
                vouchers: vouchers,
                voucherExpanded: false,
            })
        })
    }

    getEmptyVoucher() {
        const initialPrice = 20;
        return {
            id: -1,
            title: initialPrice + trans.empty_voucher,
            price: initialPrice,
            price_in_cents: initialPrice * 100,
            fee: 2,
            fee_in_cents: 200,
        }
    }

    handleVoucherClick(voucher) {
        try {
            GtmHelper.addGiftVoucher(voucher);
            this.setState({ voucherExpanded: voucher });
        } catch (error) {
            Log.exception(error, 'purchase-voucher')
        }
    }

    handleBackClick() {
        this.setState({
            voucherExpanded: false,
            sessionId: null,
            cancelOrder: null
        });
    }

    renderVouchersList() {
        return this.state.vouchers.map((item, index) => {
            return (
                <VoucherItem key={index} item={item} clickHandler={(voucherClicked) => this.handleVoucherClick(voucherClicked)} />
            )
        });
    }

    renderForm() {
        return (
            <VoucherForm item={this.state.voucherExpanded} onBackClick={() => this.handleBackClick()} />
        )
    }

    renderCancel() {
        return (
            <VoucherCancel />
        )
    }

    renderSuccess() {
        return (
            <VoucherSuccess
                sessionId={this.state.sessionId}
                onBackClick={() => this.handleBackClick()}
            />
        )
    }

    render() {
        if (this.state.sessionId) {
            return <div>{ this.renderSuccess() }</div>
        } else if (this.state.cancelOrder) {
            return <div>{ this.renderCancel() }</div>
        } else if (this.state.voucherExpanded) {
            return <div>{ this.renderForm() }</div>
        } else {
            return <div>{ this.renderVouchersList() }</div>
        }
    }
}

export default Vouchers;



// WEBPACK FOOTER //
// ./scripts/components/Vouchers.jsx